import React from "react";
import { Spinner } from "../../utils/Spinner";
import { summaryBGColorMap } from "./TaskProgressbar";

type Props = {
  step: string;
  completed: number;
  total: number;
};

export const TaskStepProgressbar: React.FC<Props> = ({
  step,
  completed,
  total,
}) => {
  const allIsDone = completed === total;

  const calcBase = Math.round((completed / total) * 100);

  const calcProgressForProgressbar = Math.max(calcBase, 0);

  const progressTotalPercentage =
    total > 0 ? `${Math.min(calcProgressForProgressbar, 100)}%` : "0%";
  const displayProgress = total > 0 ? `${Math.min(calcBase, 100)}%` : "0%";

  const inProgress = completed > 0 && !allIsDone;

  const bgColor =
    summaryBGColorMap[
      allIsDone ? "SUCCESS" : inProgress ? "STARTED" : "PENDING"
    ];

  return (
    <div className="tw-flex-1">
      <div className="tw-flex tw-items-center tw-gap-2">
        <div className="tw-w-full tw-bg-gray-200 tw-rounded-md">
          <div
            className={`tw-font-medium tw-flex tw-justify-end tw-items-center tw-gap-2 tw-p-0.5 tw-px-3 tw-rounded-md ${bgColor} tw-overflow-hidden tw-transition-all tw-duration-500 tw-ease-out tw-min-w-max`}
            style={{
              width: progressTotalPercentage,
            }}
          >
            {inProgress && <Spinner size="mini" />} {displayProgress}
          </div>
        </div>
      </div>
      <small className="tw-text-gray-500 tw-text-xs">
        {step} {completed} / {total}
      </small>
    </div>
  );
};
